import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React, { useContext } from 'react';
import styled from 'styled-components';
import { ClickableContainer, createText } from './mixins';
import { ThemeContext } from 'styled-components';

var Text = function Text(props) {
  var children = props.children,
      action = props.action;
  var theme = useContext(ThemeContext);
  var Component = styled[props.as || 'p'](_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), createText(props, theme));

  if (action) {
    return React.createElement(ClickableContainer, {
      onClick: action
    }, React.createElement(Component, null, children));
  }

  return React.createElement(Component, null, children);
};

export default Text;
Text.defaultProps = {
  type: 'body',
  fontWeight: 'regular'
};